import React from 'react';
import QuoteForm from '../components/QuoteForm';
import { useLanguage } from '../context/LanguageContext';

export default function ContactUs() {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-neutral-950 text-white pt-20">
      <section className="py-20 bg-black border-b border-neutral-800">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-6xl font-bold mb-6 text-white">{t.nav.contact}</h1>
          <p className="text-xl text-neutral-400 max-w-2xl mx-auto">
            {t.quote.subtitle}
          </p>
        </div>
      </section>
      
      {/* Reusing the QuoteForm which now contains phone, email and the form */}
      <QuoteForm />
    </div>
  );
}
